import {
  COLOR_GRAY_300,
  COLOR_SECONDARY,
  COLOR_WHITE,
  SIZE_LG,
  SIZE_MD,
  SIZE_SM,
} from '../../config/constants';

export const SPINNER_BASE_CLASS = 'spinner';

export const SPINNER_COLORS = [
  COLOR_GRAY_300,
  COLOR_SECONDARY,
  COLOR_WHITE,
];

export const SPINNER_SIZES = [
  SIZE_SM,
  SIZE_MD,
  SIZE_LG,
];
